import { render, staticRenderFns } from "./VoDPage.vue?vue&type=template&id=381742aa"
import script from "./VoDPage.vue?vue&type=script&lang=ts"
export * from "./VoDPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports